<template>
  <loading v-bind:loading="data_.loading" />
  <alert @onFire="eventCloseAlert" v-bind:data_alert="data_alert" />
    <div class="h-screen w-screen flex justify-center">
        <div class="w-5/10 md:w-5/12 lg:w-46 max-w-lg h-4/4 bg-white shadow rounded-md p-4 mt-10 md:mt-40 flex flex-col">
            <span class="text-1xl pt-7 text-center">Zona de administración</span>
        </div>
    </div>
</template>

<script lang="ts">
import {reactive} from 'vue';
//import {useRouter} from 'vue-router'
import axios from 'axios'
import Loading from '../../components/Commons/Loading.vue'
import Alert from '../../components/Commons/Alert.vue'
import {messageVaidate} from '@/api/utilities'

export default {
  name: 'LoginURL',
  components: {Loading, Alert},
  setup(){

    const data_ = reactive({
      loading: false
    });

    const data_login = reactive({
      url: ''
    });

    const data_alert = reactive({
        title: "",
        msg: "",
        description: "",
        type: "",
        open: false
    })

    const eventCloseAlert = () => {
      data_alert.open=false;
    }

    const submit = async () => {
      data_.loading = true;
      const url =  process.env.VUE_APP_BASE_URL+"/Token/admin/authenticationurl";
      
      let response = null
      try {
        response = await axios.get(url)
      } catch (e: any) {
        response = e.response || e.request;
      }

      if(response.status== 200){
        data_login.url = response.data.url;
       
        await getToken();
      }else{
        const msg = response.data.title;
        const er = messageVaidate(msg);
        data_.loading = false;
        data_alert.open = true;
        data_alert.type = "danger";
        data_alert.title = "¡Error!";
        data_alert.msg =  "Hubo un problema al tratar de obtener la url";
        data_alert.description = response.data ? er.length > 0 ? er[0].traduction_es : msg : "No se pudo establecer conexión";

        window.scrollTo(0, 0);
        await setTimeout(function() {
          data_alert.open = false;
        }, 3000); 
      }
    }

    const getToken = () => {
      window.location.href = data_login.url;
    }

    submit();

    return {
      data_login,
      data_,
      submit,
      eventCloseAlert,
      data_alert
    }

  }
}
</script>
